import React from 'react';
import PropTypes from 'prop-types';
import styles from './MatrixRow.scss';
import classNames from 'classnames';
import { subscriptionTypes } from 'rp-auth';

const { ULTIMATE } = subscriptionTypes;

const rowTitles = {
  ultimate: 'Ultimate Exclusive',
  insights: 'Insights Exclusive',
  tipping: 'Tipping Exclusive',
};

function MatrixRow({
  data, service, index, isShortList, isMobile,
}) {
  const { description, expandedDescription, packages } = data;
  const checkPackageIncluded = packages.includes(service);

  if (isMobile && !checkPackageIncluded) {
    return null;
  }

  const getRowTitle = () => {
    if (isShortList) return null;

    let currentTitle;

    switch (index) {
      case 0:
        currentTitle = rowTitles.ultimate;
        break;
      case 7:
        currentTitle = rowTitles.tipping;
        break;
      case 13:
        currentTitle = rowTitles.insights;
        break;
      default:
        currentTitle = null;
        break;
    }

    return currentTitle ? (
      <div className={styles.rowTitleWrapper}>
        <span className={styles.rowTitleBorder} />
        <span className={styles.rowTitle}>{currentTitle}</span>
        <span className={styles.rowTitleBorder} />
      </div>
    ) : null;
  };

  const checkForUltimateAccess = () => {
    if (service === ULTIMATE.toLowerCase()) {
      return true;
    }

    return checkPackageIncluded;
  };

  return (
    <div className={`${styles.root}`}>
      {!isMobile && getRowTitle()}
      <div
        className={classNames(styles.thick, {
                    [styles[`thick__${service}`]]: checkForUltimateAccess(),
                    [styles.thick__allowed]: checkForUltimateAccess(),
                    [styles.thick__emptyDescription]: isShortList && description.length === 0,
                    [styles.thick__hidden]: !isMobile
                        ? isShortList && !checkPackageIncluded
                        : isShortList,
                })}
            >
        {isMobile && checkPackageIncluded && (
        <div
          className={classNames(styles.description, {
                            [styles.description__disabled]: !checkForUltimateAccess(),
                        })}
                    >
          {expandedDescription}
        </div>
                )}

        {!isMobile && (
        <React.Fragment>
          {service !== ULTIMATE.toLowerCase() &&
                            (!checkPackageIncluded && (
                            <svg className={styles.icon}>
                              <use xlinkHref="#locked-icon" />
                            </svg>
                            ))}
          <div
            className={classNames(styles.description, {
                                [styles.description__disabled]: !checkForUltimateAccess(),
                            })}
                        >
            {isShortList ? description : expandedDescription}
          </div>
        </React.Fragment>
                )}
      </div>
    </div>
  );
}

MatrixRow.propTypes = {
  data: PropTypes.shape({
    description: PropTypes.string.isRequired,
    packages: PropTypes.array.isRequired,
  }).isRequired,
  service: PropTypes.string.isRequired,
};

export default MatrixRow;
